import * as yup from 'yup';

const optionalWithPattern = (name, pattern, message) => {
  return yup.string().test(name, message, value => {
    if (!value) return true;  // allow empty
    return pattern.test(value);
  });
};

const merchantSchemaStep3 = yup.object().shape({
  amountPerTrans: yup.string(),
  allowedTotAmtPerDay: yup.string(),
  allowedTransPerDay: yup.string()
});
const merchantSchemaStep2 = yup.object().shape({
  beneficiaryName: yup
    .string()
    .required("Beneficiary Name is required.")
    .matches(/^[a-zA-Z0-9!@#$&()-`.+,/\" ]*$/, "Invalid Beneficiary Name")
    .max(100, "Beneficiary Name must not exceed 100 characters"),

  beneficiaryAccountNo: yup
    .string()
    .required("Account Number is required")
    .matches(/^[a-zA-Z0-9]+$/, "Invalid Account Number")
    .max(20, "Account Number must not exceed 20 characters"),

  bankCode: yup
    .string()
    .required("Bank Code is required")
    .matches(/^[0-9]+$/, "Invalid Account Number")
    .min(4, "Bank code must be minimum 4 digits")
    .max(4, "Bank Code must not exceed 4 digits"),
    
  branchCode: yup
    .string()
    .required("Branch Code is required")
    .matches(/^[0-9]+$/, "Invalid Account Number")
    .min(3, "Branch code must be minimum 3 digits")
    .max(3, "Branch Code must not exceed 3 digits"),

  // transactionCode: yup
  //   .string()
  //   .test("transactionCode", "Invalid Transaction Code", (value) => {
  //     if (!value) return true; // allow empty
  //     return /^[0-9]+$/.test(value);
  //   })
  //   .max(10, "Transaction Code must not exceed 10 characters"),
});

const merchantSchemaStep1 = yup.object().shape({
  name: yup.string()
    .required('Business Name is required.')
    .matches(/^[a-zA-Z0-9!@#$&()-`.+,/\" ]*$/, 'Invalid Business Name')
    .max(100, 'Business Name must not exceed 100 characters'),

  counterId: yup.string()
    .test('counterId', 'Invalid Counter ID', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]+$/.test(value);
    }),

  vendorId: yup.string()
    .test('vendorId', 'Invalid Vendor ID', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]+$/.test(value);
    }),

  email1: yup.string()
    .test('email1', 'Invalid email address', value => {
      if (!value) return true;  // allow empty
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }),

  mccCode: yup.string()
    .required('Merchant category (segment) is required')
    .test('mccCode', 'Merchant category (segment) is required', value => {
      if (!value || value === '' || value === '-1') return false;  // must be selected
      return true;
    }),

  firstName: yup.string()
    .test('firstName', 'Invalid First Name', value => {
      if (!value) return true;  // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, 'First Name must not exceed 50 characters'),

  lastName: yup.string()
    .test('lastName', 'Invalid Last Name', value => {
      if (!value) return true;  // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, 'Last Name must not exceed 50 characters'),

  address: yup.string()
    .max(200, 'Address length exceeds the limit'),

  city: yup.string()
    .test('city', 'Invalid City', value => {
      if (!value) return true;  // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, 'City must not exceed 50 characters'),

  state: yup.string()
    .test('state', 'Invalid State', value => {
      if (!value) return true;  // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, 'State must not exceed 50 characters'),

  pincode: yup.string()
    .test('pincode', 'Invalid Pincode', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]{6}$/.test(value);
    }),

  phoneNumber: yup.string()
    .test('phoneNumber', 'Invalid Phone Number', value => {
      if (!value) return true;  // allow empty
      return /^[0-9]{10,13}$/.test(value);
    }),

  transferType: yup.string()
    .test('transferType', 'Please select a valid Transfer Type', value => {
      if (!value || value === '') return true;  // allow empty
      return true;
    }),
});

const merchantSchema = yup.object().shape({
  name: yup
    .string()
    .required("Business Name is required.")
    .matches(/^[a-zA-Z0-9!@#$&()-`.+,/\" ]*$/, "Invalid Business Name")
    .max(100, "Business Name must not exceed 100 characters"),

  counterId: yup.string().test("counterId", "Invalid Counter ID", (value) => {
    if (!value) return true; // allow empty
    return /^[0-9]+$/.test(value);
  }),

  vendorId: yup.string().test("vendorId", "Invalid Vendor ID", (value) => {
    if (!value) return true; // allow empty
    return /^[0-9]+$/.test(value);
  }),

  email1: yup.string().test("email1", "Invalid email address", (value) => {
    if (!value) return true; // allow empty
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }),

  mccCode: yup.string().test("mccCode", "Please select a valid MCC Code", (value) => {
    if (!value || value === "" || value === "-1") return true; // allow empty
    return true;
  }),

  firstName: yup
    .string()
    .test("firstName", "Invalid First Name", (value) => {
      if (!value) return true; // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, "First Name must not exceed 50 characters"),

  lastName: yup
    .string()
    .test("lastName", "Invalid Last Name", (value) => {
      if (!value) return true; // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, "Last Name must not exceed 50 characters"),

  address: yup.string().max(200, "Address length exceeds the limit"),

  city: yup
    .string()
    .test("city", "Invalid City", (value) => {
      if (!value) return true; // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, "City must not exceed 50 characters"),

  state: yup
    .string()
    .test("state", "Invalid State", (value) => {
      if (!value) return true; // allow empty
      return /^[a-zA-Z ]+$/.test(value);
    })
    .max(50, "State must not exceed 50 characters"),

  pincode: yup.string().test("pincode", "Invalid Pincode", (value) => {
    if (!value) return true; // allow empty
    return /^[0-9]{6}$/.test(value);
  }),

  phoneNumber: yup.string().test("phoneNumber", "Invalid Phone Number", (value) => {
    if (!value) return true; // allow empty
    return /^[0-9]{10,13}$/.test(value);
  }),

  transferType: yup
    .string()
    .test("transferType", "Please select a valid Transfer Type", (value) => {
      if (!value || value === "") return true; // allow empty
      return true;
    }),
  beneficiaryName: yup
    .string()
    .required("Beneficiary Name is required.")
    .matches(/^[a-zA-Z0-9!@#$&()-`.+,/\" ]*$/, "Invalid Beneficiary Name")
    .max(100, "Beneficiary Name must not exceed 100 characters"),

  beneficiaryAccountNo: yup
    .string()
    .required('Account Number is required')
    .matches(/^[a-zA-Z0-9]+$/, 'Invalid Account Number')
    .max(20, 'Account Number must not exceed 20 characters'),
  bankCode: yup
    .string()
    .required("Bank Code is required")
    .matches(/^[0-9]+$/, "Invalid Account Number")
    .min(4, "Bank code must be minimum 4 digits")
    .max(4, "Bank Code must not exceed 4 digits"),
  branchCode: yup
    .string()
    .required("Branch Code is required")
    .matches(/^[0-9]+$/, "Invalid Account Number")
    .min(3, "Branch code must be minimum 3 digits")
    .max(3, "Branch Code must not exceed 3 digits"),
  // transactionCode: yup
  //   .string()
  //   .test("transactionCode", "Invalid Transaction Code", (value) => {
  //     if (!value) return true; // allow empty
  //     return /^[0-9]+$/.test(value);
  //   })
  //   .max(10, "Transaction Code must not exceed 10 characters"),
});

export { merchantSchema, merchantSchemaStep1, merchantSchemaStep2, merchantSchemaStep3 };

